import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";
import {find} from '@elements/dom-utils';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// import * as ajaxForm from '@elements/ajax-form';
// ajaxForm.init({
//     addUrlParams: true
// });

import * as formValidation from '@elements/form-validation';
formValidation.init();

import * as productGrid from './libs/product-grid/index';
app.productGrid = productGrid.init({
    disableScrollRestoration: false
});

import * as video from './scripts/video';
video.init();

import * as collapseFilter from './scripts/collapse-filter'
collapseFilter.init();

import * as lightbox from '@elements/lightbox';
lightbox.init({
    plugins: ['video'],
    mobileSettings: {
        controls: true,
        showCloseIcon: true
    }
});

import * as anchorNav from '@elements/anchor-nav/bootstrap-5';
anchorNav.init({
        renderItem: function (text, anchor) {
            return '<li class="nav-item anchor-nav__item flex-shrink-0"><a class="nav-link js-smoothscroll__link anchor-nav__link" href="#' + anchor + '"><span class="icon icon-chevron anchor-nav__link-icon"></span>'+ text + '</span></a></li>';
        },
        smoothScroll: false,
        scrollSpy: true,
        scrollSpyTarget: '.js-anchor-nav',
        scrollSpyOffset: matchMedia('(max-width: 767px)').matches ? 152 : 200
    },
    {
        list: '.js-anchor-nav__list',
        item: '.js-anchor-nav__item'
    }
);

import * as smoothScroll from '@elements/smooth-scroll';
smoothScroll.init({scrollOffset: matchMedia('(max-width: 767px)').matches ? 152 : 190, initialPosition: true});

import * as anchorNavSticky from './scripts/anchor-nav-sticky';
anchorNavSticky.init();
